import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { UncontrolledPopover } from "../../../components/Popover";
import { RichText } from "../../../components/RichText";
import { IImageURL } from "../../../models/nominals";

import styles from "./index.module.scss";

type IProps = Immutable<{
    reviewAggregationCopy: string;
    modalContent: string | null;
    checkmarkIconURL?: IImageURL | null | undefined;
    starsImageURL?: IImageURL | null | undefined;
}>;

export const ConfiguratorReviewAggregation = (
    props: IProps,
): React.JSX.Element => {
    const buildReviewCopy = (): React.JSX.Element => {
        return (
            <>
                <RichText
                    html={props.reviewAggregationCopy}
                    className={styles.copy}
                />
                {props.checkmarkIconURL && (
                    <img
                        src={`${props.checkmarkIconURL}`}
                        aria-hidden="true"
                        alt=""
                    />
                )}
            </>
        );
    };
    const buildReviewCopyAndModalContent = (): React.JSX.Element => {
        return (
            <UncontrolledPopover
                triggerContent={buildReviewCopy()}
                triggerBtnProps={{ className: styles.button }}
                popperOptions={{
                    modifiers: [
                        {
                            name: "offset",
                            options: {
                                offset: [0, 12],
                            },
                        },
                        {
                            name: "flip",
                            options: {
                                fallbackPlacements: ["top", "bottom"],
                            },
                        },
                    ],
                    placement: "bottom",
                }}
                modalProps={{
                    className: styles.modalContent,
                    // TODO(i18n): Add context to disambiguate "Reviews" (product reviews vs review process): c("Modal label").t`Reviews`
                    contentLabel: t`Reviews`,
                    bodyOpenClassName: styles.bodyModalOpen,
                    style: {
                        overlay: {
                            backgroundColor: "transparent",
                        },
                    },
                }}
            >
                {props.starsImageURL && (
                    <img
                        src={`${props.starsImageURL}`}
                        aria-hidden="true"
                        alt=""
                    />
                )}
                {props.modalContent && <RichText html={props.modalContent} />}
            </UncontrolledPopover>
        );
    };
    return (
        <div className="configurator__review-aggregation--container">
            {!props.modalContent
                ? buildReviewCopy()
                : buildReviewCopyAndModalContent()}
        </div>
    );
};
